import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { decryptData } from '../core/utilities';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';

import { BaseComponents } from '../base.component';

@Injectable()
export class QrFormatService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService
  ) { 
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any, ref: any = '') {
    //const url = `${environment.endpointBackend}/api/qr/format?ref=${ref}`;
    const url = `${environment.endpointBackend}/api/services/buy-insurance/qrFormat?ref=${ref}`;
    // qrFormat requires the access token reference1 issued for this referenceID.
    const body = withBuyonlineAccessToken(param.referenceID || ref, this.input(param));
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(param: any, ref: any = '') {
    const self = this;
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(param, ref).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            //console.log('format',res['body'])
            // try {
            //   if(res['body']['data']){
            //     res['body']['data'] = decryptData(res['body']['data'])
            //   }
            // } catch (error) {
            //   console.log('QrFormat','error',error)
            //   reject(error);
            // }
            resolve(self.output(res['body']));
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        });
      }
    });
  }
}
